var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dress_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M7.066 0H6.012v2.7h1.054z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#063E8B",
  d: "M11.46 5.784H6.54v1.933h4.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#032E68",
  d: "M11.46 5.784H9v1.933h2.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M10.406 6.566H7.594a2.11 2.11 0 0 1-2.11-2.109v-2.11c1.318 0 2.549.66 3.28 1.756L9 4.457l.236-.354a3.94 3.94 0 0 1 3.28-1.755v2.109a2.11 2.11 0 0 1-2.11 2.11M11.46 7.621H6.54L.597 16.727v.035a29.13 29.13 0 0 0 16.804 0v-.035z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#11BC92",
  d: "M11.988 0h-1.054v2.7h1.054z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1DBF95",
  d: "M9 6.566h1.406a2.11 2.11 0 0 0 2.11-2.109v-2.11a3.94 3.94 0 0 0-3.28 1.756L9 4.457zM11.46 7.621H9V18c2.831 0 5.662-.413 8.402-1.238v-.035z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dress_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export { SvgDress as ReactComponent };
export default __webpack_public_path__ + "static/media/dress.4a343915.svg";